import axios from "axios";
const FormData = require("form-data");

// const server = window.my_domain;
var server;
// console.log(window.my_domain);



if (window.location.hostname === "localhost") {
  server = "https://api.furasmakkah.com/";
  // server = "https://api.umrahfuras.com/";

  // new12
  // console.log(server);
}
//  else if (window.location.hostname === "mobile.umrahfuras.com") {
//   server = "https://api.umrahfuras.com/";
//   console.log(server);
// }

else if (window.location.hostname === "mobile.furasmakkah.com") {
  server = "https://api.furasmakkah.com/";
  console.log(server); }



else if (window.location.hostname === "mobile.tripplanner.ae") {
  server = "https://api.furasmakkah.com/";
  console.log(server);
}else if (window.location.hostname === "mobile.tripplannerpk.com") {
  server = "https://api.furasmakkah.com/";
  console.log(server);
}

// const server = "https://panel.umrahfuras.com";
// const server = "http://192.168.2.79:8000/";














export async function SendPostRequest(endpoint, data = {}, navigate) {
  let token = localStorage.getItem("token");
  if (!token) {
    // navigate('/login');
    window.location.href = "/login";
    return;
  }

  const bodyFormData = new FormData();
  const entries = Object.entries(data);

  entries.map((entry) => {
    bodyFormData.append(entry[0], entry[1]);
  });

  try {
    // ✅ Build base + final URL with local param logic
    const baseUrl = server + endpoint;
    const finalUrl = baseUrl + window.getLocalApiQuery(baseUrl);

    const response = await axios.post(finalUrl, data, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (
      response &&
      response.data.status === "fail" &&
      response.data.message.toUpperCase() === "TOKEN EXPIRED"
    ) {
      // navigate('/login');
      // window.location.href = "/login";
      // return;
    }

    return response.data;
  } catch (error) {
    console.log("Error is <><>", error);
    if (error.response) {
      console.log("Error response:", error.response.data);
      console.log("Error status:", error.response.status);
      console.log("Error headers:", error.response.headers);
    } else if (error.request) {
      console.log("No response received:", error.request);
    } else {
      console.log("Error:", error.message);
    }
    throw error;
  }
}



















export async function SendModalPostRequest(endpoint, data = {}, navigate) {
  let token = localStorage.getItem("token");
  if (!token) {
    // navigate('/login');
    window.location.href = "/login";
    return;
  }

  const bodyFormData = new FormData();

  const entries = Object.entries(data);
  entries.map((entry) => {
    bodyFormData.append(entry[0], entry[1]);
  });

  // new 
  // console.log("Body for data:", entries);

  // console.log("Params are", data);

  try {
    const response = await axios.post(server + endpoint, bodyFormData, {
      headers: {
        Accept: "application/json",

        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response in request folder is :", response);
    // alert(response.data.message.toUpperCase());

    if (
      response &&
      response.data.status === "fail" &&
      response.data.message.toUpperCase() === "TOKEN EXPIRED"
    ) {
      // navigate('/login');
      window.location.href = "/login";
      return;
    }
    // new12
    // console.log("Response data is ", response);
    return response.data;
  } catch (error) {
    console.log("Error is <><>", error);
    if (error.response) {
      // The request was made and the server responded with an error status code
      console.log("Error response:", error.response.data);
      console.log("Error status:", error.response.status);
      console.log("Error headers:", error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      console.log("No response received:", error.request);
    } else {
      // Something happened in setting up the request that triggered an error
      console.log("Error:", error.message);
    }
    throw error;
  }
}

// const server = "https://api.umrahfuras.com/";
// const server = "http://192.168.2.79:8000/";

export async function SendGetRequest(endpoint) {
  // const token = localStorage.getItem('token');

  try {
    const response = await axios.get(server + endpoint, {
      headers: {
        Accept: "application/json",
        // 'Authorization': `Bearer ${token}`
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error:", error);
    throw error;
  }
}

// const response = await axios.post(
//           'https://api.umrahfuras.com/guest/login',
//           formData,
//           {
//             headers: {
//               'Accept': 'application/json',
//             },
//           }
//         );

// export async function SendGetRequest(endpoint, data) {
//     return await axios.get(server + endpoint, {
//         params: data
//     })
//         .then(function (response) {
//             console.log(response);
//             return response
//         })
//         .catch(function (error) {
//             console.log("error", error)
//             return error;
//         });
// }
// export async function SendPutRequest(endpoint, data) {
//     return await axios.put(server + endpoint, data, {
//         headers: headers
//     })
//         .then(function (response) {
//             return response;
//         })
//         .catch(function (error) {
//             console.log("error", error)
//             return error;
//         });
// }
// export async function SendDeleteRequest(endpoint) {
//     return await axios.delete(server + endpoint )
//         .then(function (response) {
//             return response;
//         })
//         .catch(function (error) {
//             console.log("error", error)
//             return error;
//         });
// }

export const postAxio = async (endpoint, params = {}) => {
  let token = localStorage.getItem("token");
  console.log("Token --------------------------------<>", token);

  // let data = new FormData();
  // data.append("arrival_date_from", "2020-05-17");
  // data.append("length", "100");
  // data.append("start", "1");
  // data.append("draw", "0");

  // return await axios
  //   .post(`${server}/${endpoint}`, params, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${token}`,
  //     },
  //   })
  //   .then((response) => response.data)

  const requestData = {
    arrival_date_from: "2020-05-17",
    length: "100",
    start: "1",
    draw: "0",
  };

  const config = {
    method: "post",
    url: "https://api.umrahfuras.com/api/umrah/actual-transport-activity",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: requestData,
  };

  await axios(config)
    .then((response) => {
      console.log(JSON.stringify(response));
    })
    .catch((error) => {
      console.log(error);
    });
};
